module.exports = __webpack_public_path__ + "img/operationDisinfect.718483f9.png";